import { call, put, takeEvery, takeLeading } from "redux-saga/effects";
import { xepTkbApi } from "../../../api/tkb/xepTkbApi";
import { INhomLopUpdateTKBRequest } from "../../../model/request/tkb/INhomLopUpdateTKBRequest";
import { ISuKienUpdateRequest } from "../../../model/request/tkb/ISuKienUpdateRequest";
import { IXepTKBSelectByBoMonRequest } from "../../../model/request/tkb/IXepTKBSelectByBoMonRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eXepTKBActionIds, IXepTKBActionTypes } from "../../action-types/tkb/IXepTKBActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.tkb.xepTKB;
// Marker server gắn vào message khi trùng CÓ THỂ ghi đè (xem SuKienService.UpdatesXepTKBAsync).
const TRUNG_LICH_MARKER = "[TRUNG_LICH]";
export function* xepTKBSaga(): any {
  yield takeEvery(eXepTKBActionIds.LOAD_ALL_START, loadKeHoachMonWorker);
  // takeLeading: 1 lần xếp đang chạy thì BỎ QUA các click trùng (vd double-click) -> tránh 2 request
  // song song đọc cùng state cũ rồi ghi cặp ghép không hợp lệ (block ở server check trước write-lock nên race).
  yield takeLeading(eXepTKBActionIds.UPDATE_SUKIEN_START, updateWorker);
  yield takeEvery(eXepTKBActionIds.UPDATE_GV_PH_SUKIEN_START, updateGVPHWorker);
  yield takeEvery(eXepTKBActionIds.UPDATE_NHOMLOP_SUKIEN_START, updateNhomLopSuKienWorker);
  yield takeEvery(eXepTKBActionIds.UPDATE_PHONG_HOC_SUKIEN_START, updatePhongHocWorker);
}

function* loadKeHoachMonWorker(action: IXepTKBActionTypes): any {
  const res: IBaseRespone = yield call(xepTkbApi.SelectXepTKB, action.payload as IXepTKBSelectByBoMonRequest);
  if (res.is_success) {
    yield put(mainAction.LOAD_ALL_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ALL_ERRR(res.message ?? "Có lỗi"));
  }
}

function* updateWorker(action: IXepTKBActionTypes): any {
  const request = action.payload as ISuKienUpdateRequest;
  const res: IBaseRespone = yield call(xepTkbApi.UpdateTKB, request);
  if (res.is_success) {
    yield put(mainAction.UPDATE_SUKIEN_SUCCESS(res.data));
  } else if ((res.message ?? "").startsWith(TRUNG_LICH_MARKER)) {
    // Trùng có thể ghi đè -> không toast, để page hỏi xác nhận rồi gửi lại isConfirmTrung=true.
    const message = (res.message ?? "").substring(TRUNG_LICH_MARKER.length).trim();
    yield put(mainAction.UPDATE_SUKIEN_TRUNG({ request, message }));
  } else {
    yield put(mainAction.UPDATE_SUKIEN_ERRR(res.message ?? "Có lỗi"));
  }
}


function* updateGVPHWorker(action: IXepTKBActionTypes): any {
  const res: IBaseRespone = yield call(xepTkbApi.UpdateGiaoVien, action.payload as ISuKienUpdateRequest);
  if (res.is_success) {
    yield put(mainAction.UPDATE_GV_PH_SUKIEN_SUCCESS(res.data));
  } else {
    yield put(mainAction.UPDATE_GV_PH_SUKIEN_ERRR(res.message ?? "Có lỗi"));
  }
}

function* updateNhomLopSuKienWorker(action: IXepTKBActionTypes): any {
  const res: IBaseRespone = yield call(xepTkbApi.NhomLopUpdateSuKienAsync, action.payload as INhomLopUpdateTKBRequest);
  if (res.is_success) {
    yield put(mainAction.UPDATE_NHOMLOP_SUKIEN_SUCCESS(res.data));
  } else {
    yield put(mainAction.UPDATE_NHOMLOP_SUKIEN_ERROR(res.message ?? "Có lỗi"));
  }
}


function* updatePhongHocWorker(action: IXepTKBActionTypes): any {
  const res: IBaseRespone = yield call(xepTkbApi.UpdatePhongHoc, action.payload as ISuKienUpdateRequest);
  if (res.is_success) {
    yield put(mainAction.UPDATE_PHONG_HOC_SUKIEN_SUCCESS(res.data));
  } else {
    yield put(mainAction.UPDATE_PHONG_HOC_SUKIEN_ERRR(res.message ?? "Có lỗi"));
  }
}
